import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../config/axiosConfig";

/**
 * API 1: Update hardware description data
 */
export const updateHardwareDescriptionData = createAsyncThunk(
    "updateDardware/updateHardwareDescriptionData",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.put(
                "/hardware-description/updatemany",
                payload
            );
            return res.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

/**
 * API 2: Update task / department / expenses data
 */
export const updateDescriptionData = createAsyncThunk(
    "updateDardware/updateTaskData",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await axiosInstance.put(
                "/descriptiontask/updatemany",
                payload
            );
            return res.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const updateHardwareDataSlice = createSlice({
    name: "updateHardware",
    initialState: {
        loading: false,
        success: false,
        error: null,
        response: null,
    },
    reducers: {
        resetUpdateDardwareState: (state) => {
            state.loading = false;
            state.success = false;
            state.error = null;
            state.response = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // API 1
            .addCase(updateHardwareDescriptionData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateHardwareDescriptionData.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.response = action.payload;
            })
            .addCase(updateHardwareDescriptionData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // API 2
            .addCase(updateDescriptionData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateDescriptionData.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.response = action.payload;
            })
            .addCase(updateDescriptionData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { resetUpdateDardwareState } =
    updateHardwareDataSlice.actions;

export default updateHardwareDataSlice.reducer;
